import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../screens/Login";
import Dashboard from "../screens/Dashboard";
import ProtectedRoute from "../components/ProtectedRoute";
import Projects from "../screens/project/Projects";
import ForgotPassword from "../screens/ForgotPassword";
import ServiceCall from "../screens/serviceCall/ServiceCall";
import TimeSheets from "../screens/timeSheet/TimeSheets";
import TimeSheetProject from "../screens/timeSheet/TimeSheetProject";
import ProfilePage from "../screens/profile/ProfilePage";
import ResetEmailConfirmation from "../screens/ResetEmailConfirmation";
import NewProject from "../screens/project/NewProject";
import EmployeesList from "../screens/profile/EmployeesList";
import NewEmployee from "../screens/profile/NewEmployee";
import NewServiceCall from "../screens/serviceCall/NewServiceCall";
import TimeSheetDetails from "../screens/timeSheet/TimeSheetDetails";
import TimeSheetProjectDetails from "../screens/timeSheet/TimeSheetProjectDetails";
import ProjectDetails from "../components/projectComponents/ProjectDetails";
import ServiceCallDetails from "../components/serviceComponents/ServiceCallDetails";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route
          path="/resetemailconfirmation"
          element={<ResetEmailConfirmation />}
        />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addproject"
          element={
            <ProtectedRoute>
              <NewProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/servicecall"
          element={
            <ProtectedRoute>
              <ServiceCall />
            </ProtectedRoute>
          }
        />
        <Route
          path="/timesheets"
          element={
            <ProtectedRoute>
              <TimeSheets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/timesheetproject"
          element={
            <ProtectedRoute>
              <TimeSheetProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/timesheetdetails"
          element={
            <ProtectedRoute>
              <TimeSheetDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/timesheetprojectdetails"
          element={
            <ProtectedRoute>
              <TimeSheetProjectDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profilepage"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employeeslist"
          element={
            <ProtectedRoute>
              <EmployeesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projectdetails/:id"
          element={
            <ProtectedRoute>
              <ProjectDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newemployee"
          element={
            <ProtectedRoute>
              <NewEmployee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newservicecall"
          element={
            <ProtectedRoute>
              <NewServiceCall />
            </ProtectedRoute>
          }
        />
        <Route
          path="/servicedetails/:id"
          element={
            <ProtectedRoute>
              <ServiceCallDetails />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
